
<template>
    <div class="">
        <ul class="users_top">
            <li class="Gross_Deposit">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>Visitor Traffic</span></div>
                    <div class="total_ftd_right" v-if="this.trend.screenPageViews > 0 ">
                     <span>{{ trend.screenPageViews }}%</span>
                     <img  src="../assets/img/total_ftd_rise.webp" alt="">
                    </div>
                    <div class="total_ftd_right" v-else>
                        <span style="color: #EE5253">{{ trend.screenPageViews }}%</span>
                        <img  src="../assets/img/total_ftd_decline.webp" alt="">
                    </div>
                </div>
                <h3>{{ digital.screenPageViews }}</h3>
            </li>
            <li class="Net_Deposit">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>Unique Visitor</span></div>
                    <div class="total_ftd_right" v-if="this.trend.activeUsers > 0 ">
                        <span>{{ trend.activeUsers }}%</span>
                        <img src="../assets/img/total_ftd_rise.webp" alt="">
                    </div>
                    <div class="total_ftd_right" v-else>
                        <span style="color: #EE5253">{{ trend.activeUsers }}%</span>
                        <img  src="../assets/img/total_ftd_decline.webp" alt="">
                    </div>
                </div>
                <h3>{{ digital.activeUsers }}</h3>
            </li>
            <li class="Net_Gross">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>Page/Visit</span></div>
                    <div class="total_ftd_right" v-if="this.trend.screenPageViewsPerSession > 0 ">
                        <span>{{ trend.screenPageViewsPerSession }}%</span>
                        <img src="../assets/img/total_ftd_rise.webp" alt="">
                    </div>
                    <div class="total_ftd_right" v-else>
                        <span style="color: #EE5253">{{ trend.screenPageViewsPerSession }}%</span>
                        <img  src="../assets/img/total_ftd_decline.webp" alt="">
                    </div>
                </div>
                <h3>{{ digital.screenPageViewsPerSession }}</h3>

            </li>
            <li class="Withdrawal">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>AVG Visit Duration</span></div>
                    <div class="total_ftd_right" v-if="this.trend.averageSessionDuration > 0 ">
                        <span>{{ trend.averageSessionDuration }}%</span>
                        <img src="../assets/img/total_ftd_rise.webp" alt="">
                    </div>
                    <div class="total_ftd_right" v-else>
                        <span style="color: #EE5253">{{ trend.averageSessionDuration }}%</span>
                        <img  src="../assets/img/total_ftd_decline.webp" alt="">
                    </div>
                </div>
                <h3>{{ digital.averageSessionDuration }}</h3>

            </li>
            <li class="Bounce_Rate">
                <div class="total_ftd">
                    <div class="total_ftd_left"><span>Bounce Rate</span></div>
                    <div class="total_ftd_right" v-if="this.trend.bounceRate > 0 ">
                        <span>{{ trend.bounceRate }}%</span>
                        <img src="../assets/img/total_ftd_rise.webp" alt="">
                    </div>
                    <div class="total_ftd_right" v-else>
                        <span style="color: #EE5253">{{ trend.bounceRate }}%</span>
                        <img  src="../assets/img/total_ftd_decline.webp" alt="">
                    </div>
                </div>
                <h3>{{ digital.bounceRate }}</h3>

            </li>
        </ul>
        <div class="users_bottom">
            <div id="trendcontainer" style="height: 600px;width: 1540px;background-color: #fff;border-radius: 10px;overflow: hidden;">
            </div>
        </div>

        <div class="trend_load">
            <i class="el-icon-loading"></i>
        </div>
    </div>
</template>
<style>
.Account_Type .users_top li{max-width: 310px;padding: 20px 35px;}
</style>
<script>
var echarts = require('echarts')
import $ from 'jquery'
import cookies from 'js-cookie'
export default {
    data () {
        return {
            trend:{},
            digital: {},
            trend_option: {
                title: {
                    text: ''
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: []
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: []
                },
                yAxis: {
                    type: 'value'
                },
                series: [

                ]
            },
            users: {
                lastings: '',
                days: '',
                timeUnit: '',
                traffic: '',

            },
        }
    },
    watch: {
        users: {
            handler: function (oldval, newval) {
                if (JSON.stringify(newval.lastings) != "null" & JSON.stringify(newval.days) != "null" & JSON.stringify(newval.timeUnit) != "null") {
                    this.getDatas()
                }
            },
            deep: true
        },
        'traffic' (oldval, newval) {
            if (oldval != newval) {
                this.getDatas()
            }
        },

    },
    mounted () {
        let this_s = this
        setInterval(function () {
            this_s.users.lastings = sessionStorage.getItem("lasting")
            this_s.users.days = sessionStorage.getItem("days")
            this_s.users.timeUnit = sessionStorage.getItem("timeUnit")
            this_s.users.traffic = sessionStorage.getItem("traffic")
            // console.log(this.users.lastings,this.users.days,this.users.timeUnit);
        }, 2000)
        // this.getDatas()
        var typedom = document.getElementById('trendcontainer')
        var myChart = echarts.init(typedom, null, {
            renderer: 'canvas',
            useDirtyRect: false,
        })
        var trend_option = this.trend_option
        if (trend_option && typeof trend_option === 'object') {
            myChart.setOption(trend_option)
        }
        window.addEventListener('resize', myChart.resize)
        setInterval(function () {
            myChart.setOption(trend_option)
        }, 1000)
    },
    
    methods: {
        getDatas () {
            let this_f = this
            $.ajax({
                type: "get",
                url: "https://google-analytics-test.canglankeji.com/api/traffic/trend",
                headers: {
                    Authorization: "Bearer " + cookies.get("token"),
                },
                data: {
                    // type: 'users',
                    baseTime: this.users.lastings,
                    value: this.users.days,
                    timeUnit: this.users.timeUnit,
                    domain: this.users.traffic,
                    
                    // baseTime: "2023-03-25",
                    // value: "3",
                    // timeUnit: "day",
                },
                dataType: 'json',
                success: function (res) {
                    // console.log(res)
                    if (res.message == "OK") {
                        this_f.digital = res.result.total
                        this_f.trend =  res.result.trend
                        console.log(this_f.trend);
                        // console.log(this_f.option)
                        for (let index = 0; index < res.result.line.xAxis.length; index++) {
                            this_f.trend_option.xAxis.data = (res.result.line.xAxis)
                        }
                        var arrer = []
                        var teeda = []
                        this_f.series = []
                        for (let index = 0; index < res.result.line.series.length; index++) {
                            arrer.push(res.result.line.series[index].name)
                            teeda.push({
                                name: res.result.line.series[index].name,
                                type: 'line',
                                data: res.result.line.series[index].data,
                            })
                        }
                        this_f.trend_option.legend.data = arrer
                        this_f.trend_option.series = teeda


                        $(".trend_load").hide()
                    }
                }
            })
            // console.log(this.trend_option)
        }

    },
}
</script>



// WEBPACK FOOTER //
// src/views/Trend.vue